import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const argocdContentExtension: ExtensionDefinition = EntityContentBlueprint.make({
  name: 'argocdContent',
  params: {
    path: '/argocd',
    title: 'ArgoCD',
    filter: 'has:metadata.annotations.argocd/app-name',
    loader: () =>
      import('../components/ArgocdContent').then(m => <m.ArgocdContent />),
  },
});
